import Swiper from "swiper/bundle";
export default function networkJs() {
	// Numbers
	var routesPagination = new Swiper(".routesPagination", {
		slidesPerView: "auto",
		spaceBetween: 40,
		freeMode: true,
		slideToClickedSlide: true,
	});

	// Images
	var routesImages = new Swiper(".routesImages", {
		autoHeight: false,
		slidesPerView: 1,
		effect: "fade",
		allowTouchMove: false,
		breakpoints: {
			1100: {
				allowTouchMove: true,
			},
		},
		thumbs: {
			swiper: routesPagination,
		},
	});

	// Ports
	var routesRoutes = new Swiper(".routesRoutes", {
		autoHeight: false,
		slidesPerView: 1,
		effect: "fade",
	});

	// document
	// 	.querySelector(".routesPagination .swiper-slide")
	// 	.classList.add("swiper-slide-thumb-active");
	// // setTimeout(() => {
	// document
	// 	.querySelectorAll(".routesPagination .swiper-slide")
	// 	.forEach((elem, index) => {
	// 		elem.addEventListener("click", function () {
	// 			routesImages.slideTo(index);
	// 		});
	// 	});
	// }, 100);

	routesImages.on("slideChange", function () {
		routesRoutes.slideTo(routesImages.activeIndex);
	});
	routesRoutes.on("slideChange", function () {
		routesImages.slideTo(routesRoutes.activeIndex);
		// document
		// 	.querySelector(".routesPagination .swiper-slide-thumb-active")
		// 	.classList.remove("swiper-slide-thumb-active");
		// document
		// 	.querySelector(
		// 		`.routesPagination .swiper-slide:nth-child(${
		// 			routesRoutes.activeIndex + 1
		// 		})`
		// 	)
		// 	.classList.add("swiper-slide-thumb-active");
	});
	routesRoutes.on("transitionStart", function () {
		const activeSliderContents = document.querySelector(
			".routesRoutes .swiper-slide-active > div"
		);

		if (activeSliderContents.innerHTML.trim() !== "") {
			// Do something if the div has contents
			document.querySelector(".routesRoutes").parentNode.style.opacity = 1;
		} else {
			// Do something else if the div is empty
			document.querySelector(".routesRoutes").parentNode.style.opacity = 0;
		}
	});
}
